import gql from 'graphql-tag';

const SEO_TOTAL_MARKERS = gql`
  query seoNMarkers($cityId: String!, $filters: FiltersInput) {
    search(cityId: $cityId, filters: $filters) {
      totalMarkers
    }
  }
`;

export const getTotalMarkersQuery = client => async (cityId, filters) => {
  const { data } = await client.query({
    query: SEO_TOTAL_MARKERS,
    variables: { cityId, filters }
  });
  return data?.search;
};

const SEO_MARKERS = gql`
  query seoMarkers($cityId: String!, $filters: FiltersInput) {
    search(cityId: $cityId, filters: $filters) {
      totalMarkers
      markersMinimumPrice
      markersMaximumPrice
      markers {
        id
        coord
        instantBooking
        minimumPrice
        so
        totalCountMultilisting
      }
    }
    geocodeLocation(locationString: $cityId) {
      lat
      lng
    }
  }
`;

export const getMarkersQuery = client => async (cityId, filters) => {
  const { data } = await client.query({
    query: SEO_MARKERS,
    variables: { cityId, filters }
  });
  return data;
};

const SEO_SEARCH = gql`
  query seoFullSearch(
    $cityId: String!
    $locale: String!
    $filters: FiltersInput
    $limit: Int
  ) {
    search(cityId: $cityId, filters: $filters, limit: $limit) {
      totalMarkers
      markersMinimumPrice
      markersMaximumPrice
      markers {
        id
        coord
        instantBooking
        minimumPrice
        so
        totalCountMultilisting
      }
      homecards(locale: $locale) {
        checked
        currencyIsoCode
        firstAvailableDate
        id
        city
        isInstantBooking
        noSecurityDeposit
        isFavorite
        mainPhotoUrl
        reviews {
          ratingAverage
        }
        title
        description
        type
        url
        features
        area
        roomArea
        offers {
          discountType
          discountValue
        }
        allowsPermanentContract
        numberOfBathrooms
        numberOfBedrooms
        isBestChoice
        location
        landlordId
        so
        photoIds
        otherPropertyPhotoIds
        displayPrice
        billsIncluded
      }
    }
  }
`;

export const getSeoSearchResults =
  client => async (cityId, locale, filters, limit) => {
    const { data } = await client.query({
      query: SEO_SEARCH,
      variables: { cityId, locale, filters, limit }
    });
    return data?.search;
  };

const SEO_INITIAL_SEARCH = gql`
  query seoFullSearch(
    $cityId: String!
    $locale: String!
    $filters: FiltersInput
    $limit: Int
  ) {
    search(cityId: $cityId, filters: $filters, limit: $limit) {
      markersMinimumPrice
      markersMaximumPrice
      homecards(locale: $locale) {
        checked
        currencyIsoCode
        firstAvailableDate
        id
        city
        isInstantBooking
        noSecurityDeposit
        isFavorite
        mainPhotoUrl
        reviews {
          ratingAverage
        }
        title
        description
        type
        url
        features
        area
        roomArea
        offers {
          discountType
          discountValue
        }
        allowsPermanentContract
        numberOfBathrooms
        numberOfBedrooms
        isBestChoice
        location
        landlordId
        so
        photoIds
        otherPropertyPhotoIds
        displayPrice
        billsIncluded
      }
    }
  }
`;

export const getInitialSeoSearchResults =
  client => async (cityId, locale, filters, limit) => {
    const { data } = await client.query({
      query: SEO_INITIAL_SEARCH,
      variables: { cityId, locale, filters, limit }
    });
    return data?.search;
  };
